<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar"> </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img :src="logo" class="navbar-brand-img" alt="..." />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <a slot="title-container" class="nav-link" href="#" role="button">
              <b-media class="align-items-center">
                <span
                  class="avatar avatar-sm rounded-circle bg-primary text-white"
                >
                  {{
                    userMe.name
                      ? userMe.name[0].toUpperCase()
                      : userMe.username
                      ? userMe.username[0].toUpperCase()
                      : '-'
                  }}
                </span>
              </b-media>
            </a>

            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ $t('welcome.value') }}!</h6>
            </div>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>{{ $t('myProfile.value') }}</span>
            </router-link>
            <router-link to="/settings" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>{{ $t('settings.value') }}</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a @click="onLogout()" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>{{ $t('logout.value') }}</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
        <!--Divider-->
        <!-- <hr class="my-3"> -->
        <!--Heading-->
        <!-- <h6 class="navbar-heading text-muted">Documentation</h6>

                <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/alerts/argon-dashboard">
                            <i class="ni ni-spaceship"></i> Getting started
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
                            <i class="ni ni-palette"></i> Foundation
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/alerts/argon-dashboard">
                            <i class="ni ni-ui-04"></i> Components
                        </a>
                    </li>
                </ul> -->
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from '@/components/NavbarToggleButton';
import { getUserMe } from '@/services/users';

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton,
  },
  props: {
    logo: {
      type: String,
      default: 'img/app/logo_zai.png',
      description: 'Sidebar app logo',
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item',
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  mounted() {
    this.getUserMeData();
  },
  data() {
    return {
      userMe: {},
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    onLogout() {
      this.$session.remove('token');
      localStorage.clear();
      this.$router.push('/landing');
    },
    async getUserMeData() {
      var id = this.$session.get('user_id');
      const response = await getUserMe(id);

      if (response.status === 200) {
        this.userMe = response.data;
      }
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
